import React from "react";
import "./ClockIconSprite.css";

// 定义所有可用的时钟图标类型
export type ClockIconType =
  | "close"
  | "trash"
  | "dots"
  | "pause"
  | "play"
  | "stop"
  | "arrow-back"
  | "menu"
  | "sun-high"
  | "sun-off";

interface ClockIconSpriteProps {
  type?: ClockIconType;
  className?: string;
  size?: number | string;
  color?: string;
}

// SVG sprite 定义
const sprite = (
  <svg style={{ display: "none" }} aria-hidden="true" focusable="false">
    <symbol
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="cmi-close"
    >
      <circle opacity="0.1" cx="12" cy="12" r="12" fill="currentColor"></circle>
      <path
        d="M9.17157 9.17157L14.8284 14.8284M14.8284 9.17157L9.17157 14.8284"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="cmi-trash"
    >
      <path
        d="M4 7H20M10 11V17M14 11V17M5 7L6 19C6 19.5304 6.21071 20.0391 6.58579 20.4142C6.96086 20.7893 7.46957 21 8 21H16C16.5304 21 17.0391 20.7893 17.4142 20.4142C17.7893 20.0391 18 19.5304 18 19L19 7M9 7V4C9 3.73478 9.10536 3.48043 9.29289 3.29289C9.48043 3.10536 9.73478 3 10 3H14C14.2652 3 14.5196 3.10536 14.7071 3.29289C14.8946 3.48043 15 3.73478 15 4V7"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="cmi-dots"
    >
      <path
        d="M4 12C4 12.2652 4.10536 12.5196 4.29289 12.7071C4.48043 12.8946 4.73478 13 5 13C5.26522 13 5.51957 12.8946 5.70711 12.7071C5.89464 12.5196 6 12.2652 6 12C6 11.7348 5.89464 11.4804 5.70711 11.2929C5.51957 11.1054 5.26522 11 5 11C4.73478 11 4.48043 11.1054 4.29289 11.2929C4.10536 11.4804 4 11.7348 4 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M11 12C11 12.2652 11.1054 12.5196 11.2929 12.7071C11.4804 12.8946 11.7348 13 12 13C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11C11.7348 11 11.4804 11.1054 11.2929 11.2929C11.1054 11.4804 11 11.7348 11 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M18 12C18 12.2652 18.1054 12.5196 18.2929 12.7071C18.4804 12.8946 18.7348 13 19 13C19.2652 13 19.5196 12.8946 19.7071 12.7071C19.8946 12.5196 20 12.2652 20 12C20 11.7348 19.8946 11.4804 19.7071 11.2929C19.5196 11.1054 19.2652 11 19 11C18.7348 11 18.4804 11.1054 18.2929 11.2929C18.1054 11.4804 18 11.7348 18 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="cmi-pause"
    >
      <path
        d="M9 4H7C6.46957 4 5.96086 4.21071 5.58579 4.58579C5.21071 4.96086 5 5.46957 5 6V18C5 18.5304 5.21071 19.0391 5.58579 19.4142C5.96086 19.7893 6.46957 20 7 20H9C9.53043 20 10.0391 19.7893 10.4142 19.4142C10.7893 19.0391 11 18.5304 11 18V6C11 5.46957 10.7893 4.96086 10.4142 4.58579C10.0391 4.21071 9.53043 4 9 4Z"
        fill="currentColor"
      ></path>
      <path
        d="M17 4H15C14.4696 4 13.9609 4.21071 13.5858 4.58579C13.2107 4.96086 13 5.46957 13 6V18C13 18.5304 13.2107 19.0391 13.5858 19.4142C13.9609 19.7893 14.4696 20 15 20H17C17.5304 20 18.0391 19.7893 18.4142 19.4142C18.7893 19.0391 19 18.5304 19 18V6C19 5.46957 18.7893 4.96086 18.4142 4.58579C18.0391 4.21071 17.5304 4 17 4Z"
        fill="currentColor"
      ></path>
      <path
        d="M9 4H7C6.46957 4 5.96086 4.21071 5.58579 4.58579C5.21071 4.96086 5 5.46957 5 6V18C5 18.5304 5.21071 19.0391 5.58579 19.4142C5.96086 19.7893 6.46957 20 7 20H9C9.53043 20 10.0391 19.7893 10.4142 19.4142C10.7893 19.0391 11 18.5304 11 18V6C11 5.46957 10.7893 4.96086 10.4142 4.58579C10.0391 4.21071 9.53043 4 9 4Z"
        stroke="currentColor"
      ></path>
      <path
        d="M17 4H15C14.4696 4 13.9609 4.21071 13.5858 4.58579C13.2107 4.96086 13 5.46957 13 6V18C13 18.5304 13.2107 19.0391 13.5858 19.4142C13.9609 19.7893 14.4696 20 15 20H17C17.5304 20 18.0391 19.7893 18.4142 19.4142C18.7893 19.0391 19 18.5304 19 18V6C19 5.46957 18.7893 4.96086 18.4142 4.58579C18.0391 4.21071 17.5304 4 17 4Z"
        stroke="currentColor"
      ></path>
    </symbol>
    <symbol
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="cmi-play"
    >
      <path
        d="M6 4.00001V20C5.99995 20.1779 6.04737 20.3527 6.13738 20.5061C6.22739 20.6596 6.35672 20.7863 6.51202 20.8731C6.66733 20.96 6.84299 21.0038 7.02088 21.0001C7.19878 20.9964 7.37245 20.9452 7.524 20.852L20.524 12.852C20.6696 12.7625 20.7898 12.6372 20.8733 12.4881C20.9567 12.3389 21.0005 12.1709 21.0005 12C21.0005 11.8291 20.9567 11.6611 20.8733 11.5119C20.7898 11.3628 20.6696 11.2375 20.524 11.148L7.524 3.14801C7.37245 3.05477 7.19878 3.00366 7.02088 2.99994C6.84299 2.99623 6.66733 3.04004 6.51202 3.12687C6.35672 3.21369 6.22739 3.34038 6.13738 3.49387C6.04737 3.64736 5.99995 3.82208 6 4.00001Z"
        fill="currentColor"
      ></path>
    </symbol>
    <symbol
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="cmi-stop"
    >
      <path
        d="M17 4H7C6.20435 4 5.44129 4.31607 4.87868 4.87868C4.31607 5.44129 4 6.20435 4 7V17C4 17.7956 4.31607 18.5587 4.87868 19.1213C5.44129 19.6839 6.20435 20 7 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V7C20 6.20435 19.6839 5.44129 19.1213 4.87868C18.5587 4.31607 17.7956 4 17 4Z"
        fill="currentColor"
      ></path>
    </symbol>
    <symbol
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="cmi-arrow-back"
    >
      <path
        d="M12 8L8 12M8 12L12 16M8 12H16M12 3C19.2 3 21 4.8 21 12C21 19.2 19.2 21 12 21C4.8 21 3 19.2 3 12C3 4.8 4.8 3 12 3Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      id="cmi-menu"
    >
      <path
        d="M4 6.3252H20M4 12.3252H20M4 18.3252H20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="cmi-sun-high"
    >
      <path
        d="M6.34302 17.657L4.92902 19.071M6.34302 6.343L4.92902 4.929M17.657 6.343L19.071 4.929M17.657 17.657L19.071 19.071M4 12H2M12 4V2M20 12H22M12 20V22M14.828 14.828C15.21 14.459 15.5148 14.0176 15.7244 13.5296C15.934 13.0416 16.0444 12.5167 16.049 11.9856C16.0536 11.4545 15.9524 10.9278 15.7513 10.4362C15.5501 9.9446 15.2531 9.49799 14.8776 9.12242C14.502 8.74685 14.0554 8.44984 13.5638 8.24871C13.0722 8.04759 12.5455 7.94638 12.0144 7.951C11.4833 7.95561 10.9584 8.06596 10.4704 8.2756C9.98235 8.48523 9.54097 8.78996 9.17198 9.172C8.44335 9.92641 8.04017 10.9368 8.04928 11.9856C8.0584 13.0344 8.47907 14.0376 9.22071 14.7793C9.96234 15.5209 10.9656 15.9416 12.0144 15.9507C13.0632 15.9598 14.0736 15.5566 14.828 14.828Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="cmi-settings"
    >
      <path
        d="M19.875 6.27002C20.2187 6.46548 20.5041 6.74899 20.7018 7.09137C20.8995 7.43376 21.0025 7.82265 21 8.21802V15.502C21 16.311 20.557 17.057 19.842 17.45L13.092 21.72C12.7574 21.9037 12.3818 22.0001 12 22.0001C11.6182 22.0001 11.2426 21.9037 10.908 21.72L4.158 17.45C3.80817 17.2588 3.51612 16.9772 3.31241 16.6345C3.1087 16.2918 3.0008 15.9007 3 15.502V8.21702C3 7.40802 3.443 6.66302 4.158 6.27002L10.908 2.29002C11.2525 2.10005 11.6396 2.00043 12.033 2.00043C12.4264 2.00043 12.8135 2.10005 13.158 2.29002L19.908 6.27002H19.875Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      id="cmi-sun-off"
    >
      <path
        d="M3 3L21 21M16 12C16 10.9391 15.5786 9.92172 14.8284 9.17157C14.0783 8.42143 13.0609 8 12 8M9.16601 9.177C8.41625 9.92756 7.99535 10.9452 7.99591 12.0061C7.99647 13.067 8.41845 14.0842 9.16901 14.834C9.91958 15.5838 10.9372 16.0047 11.9981 16.0041C13.059 16.0035 14.0762 15.5816 14.826 14.831M3 12H4M12 3V4M20 12H21M12 20V21M5.6 5.6L6.3 6.3M18.4 5.6L17.7 6.3M17.7 17.7L18.4 18.4M6.3 17.7L5.6 18.4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      id="cmi-filter-off"
    >
      <path
        d="M4 4.3252H20V6.4972C19.9999 7.02758 19.7891 7.53621 19.414 7.9112L15 12.3252V19.3252L9 21.3252V12.8252L4.52 7.8972C4.18545 7.52912 4.00005 7.04959 4 6.5522V4.3252Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
    <symbol
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 25"
      id="cmi-filter-on"
    >
      <path
        d="M4 4.3252H20V6.4972C19.9999 7.02758 19.7891 7.53621 19.414 7.9112L15 12.3252V19.3252L9 21.3252V12.8252L4.52 7.8972C4.18545 7.52912 4.00005 7.04959 4 6.5522V4.3252Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </symbol>
  </svg>
);

const ClockIconSprite: React.FC<ClockIconSpriteProps> = () => {
  return <>{sprite}</>;
};

export default ClockIconSprite;
